var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8A1538;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,17.8c0,0.1,0,0.1,0,0.1c-0.7,3.1-2.3,5.6-4.7,7.6s-5.1,2.9-8.3,2.9c-1.7,0-3.3-0.3-4.9-1 c-1.6-0.6-3-1.5-4.2-2.7l-2.2,2.2c-0.2,0.2-0.5,0.3-0.8,0.3S2.2,27.1,2,26.9c-0.2-0.2-0.3-0.5-0.3-0.8v-7.8c0-0.3,0.1-0.6,0.3-0.8 c0.2-0.2,0.5-0.3,0.8-0.3h7.8c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8l-2.4,2.4 c0.8,0.8,1.8,1.4,2.8,1.8c1,0.4,2.1,0.6,3.3,0.6c1.6,0,3-0.4,4.3-1.1s2.4-1.8,3.2-3.1c0.1-0.2,0.4-0.9,0.9-2 c0.1-0.3,0.3-0.4,0.5-0.4h3.3c0.2,0,0.3,0.1,0.4,0.2C27.9,17.5,27.9,17.6,27.9,17.8L27.9,17.8z M28.4,3.9v7.8 c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3h-7.8c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8 l2.4-2.4c-1.7-1.6-3.7-2.4-6.1-2.4c-1.6,0-3,0.4-4.3,1.1S8.2,9,7.4,10.3c-0.1,0.2-0.4,0.9-0.9,2c-0.1,0.3-0.3,0.4-0.5,0.4H2.5 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4v-0.1C2.7,9,4.3,6.5,6.6,4.5C9,2.6,11.8,1.6,15,1.6c1.7,0,3.3,0.3,4.9,1 c1.6,0.6,3,1.6,4.3,2.7l2.3-2.2c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3C28.2,3.3,28.4,3.6,28.4,3.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.06463625beed263f288180ca9336b11b.svg";
export { ForwardRef as ReactComponent };